import { useState } from 'react'

import { PanelContainer } from '@/components/ui'
import { TourPlanI } from '@/features/floor-plan'

import { CreateTourPlan } from './CreateTourPlan'
import { TourPlanCheckPoints } from './TourPlanCheckPoints'
import { TourPlansList } from './TourPlansList'

enum TourPlansState {
  List,
  CheckPoints,
  Create,
}

export interface TourPlansPanelIProps {
  tourPlans: TourPlanI[]
  facilityId: string
  currentFloorId: string
  onDeviceItemHoverIn: (deviceIds: string) => void
  onDeviceItemsHoverIn?: (deviceIds: string[]) => void
  onDeviceItemHoverOut: () => void
}

export const TourPlansPanel = ({
  tourPlans,
  facilityId,
  currentFloorId,
  onDeviceItemHoverIn,
  onDeviceItemsHoverIn,
  onDeviceItemHoverOut,
}: TourPlansPanelIProps) => {
  const [tourPlanId, setTourPlanId] = useState<string>(null)
  const [viewState, setViewState] = useState<TourPlansState>(
    TourPlansState.List
  )

  const handleTourPlan = (id?: string) => {
    setTourPlanId(id)
    setViewState(id ? TourPlansState.CheckPoints : TourPlansState.List)
  }

  const handleUpdateTourPlan = (id: string) => {
    setTourPlanId(id)
  }

  const handleCreateTourPlan = () => {
    setViewState(TourPlansState.Create)
  }

  const handleDeleteTourPlan = () => {
    setViewState(TourPlansState.List)
  }

  return (
    <PanelContainer w='390px'>
      {viewState === TourPlansState.List && (
        <TourPlansList
          facilityId={facilityId}
          onCreateTourPlanClick={handleCreateTourPlan}
          onDeviceItemHoverIn={onDeviceItemsHoverIn}
          onDeviceItemHoverOut={onDeviceItemHoverOut}
          onTourPlanClick={handleTourPlan}
          tourPlans={tourPlans}
        />
      )}
      {viewState === TourPlansState.CheckPoints && (
        <TourPlanCheckPoints
          currentFloorId={currentFloorId}
          facilityId={facilityId}
          onClose={handleTourPlan}
          onDeleteTourPlan={handleDeleteTourPlan}
          onDeviceItemHoverIn={onDeviceItemHoverIn}
          onUpdateTourPlan={handleUpdateTourPlan}
          tourPlanId={tourPlanId}
        />
      )}
      {viewState === TourPlansState.Create && (
        <CreateTourPlan
          currentFloorId={currentFloorId}
          facilityId={facilityId}
          onClose={handleTourPlan}
        />
      )}
    </PanelContainer>
  )
}
